<style scoped>

.logo {
  max-height: 250px;
  max-width: 250px;
  margin-bottom: 20px;
}
.wrapper {
  margin-top: -25px;
}

</style>

<template>

<v-layout class="wrapper">
    <v-flex xs12 class="mx-auto">
      <v-flex xs12>
        <v-layout row wrap justify-center>
          <v-img :src="`../images/logo.svg`" class="transparent logo pointer mx-auto"></v-img>
        </v-layout>
      </v-flex>
        <v-card color="transparent" flat class="px-2 py-2 text-xs-center">
            <!-- <h1 class="display-2 mb-2" id="signInTitle" ref="title">{{content.title}}</h1> -->
            <loading v-if="loading" />
            <v-form @submit.prevent="login" ref="form">
                <v-expand-transition>
                  <v-alert :value="loginErr" color="error" icon="warning" outline class="mb-3">
                    {{loginErr}}
                  </v-alert>
                </v-expand-transition>
                <v-text-field placeholder=" " ref="email" v-model="form.email" :label="content.email" type="email" :rules="[rulesE.required]" autocomplete="username" autofocus dir="ltr" class="text-xs-left"></v-text-field>
                <v-text-field placeholder=" " v-model="form.password" :label="content.password" type="password" :rules="[rulesP.required]" autocomplete="current-password"></v-text-field>
                <v-btn dark color="blue" type="submit" :loading="loading" block class="pt-1">{{content.title}}</v-btn>
            </v-form>
            <v-layout justify-center wrap>
                <router-link to="/signup" style="text-decoration:none">
                    <v-btn flat>{{content.signup}}</v-btn>
                </router-link>
                <Forgotpwd/>
            </v-layout>
        </v-card>
        <Language/>
    </v-flex>
</v-layout>

</template>

<script>

import Loading from "../General/loading";
import Language from '../tools/language';
import Forgotpwd from '../user/forgotpwd';
export default {
    components: {
        Loading, Language, Forgotpwd
    },
    data() {
        return {
            form: {
                client_id: 2,
                client_secret: "dXccV61flMlRyfxIPnOpvB4DC9ZE2CaXq9wUekfZ",
                grant_type: "password",
                email: null,
                password: null
            },
            loading: false,
            rulesE: {
                required: value => !!value || this.content.validation.email
            },
            rulesP: {
                required: value => !!value || this.content.validation.password
            },
            loginErr: false,
            locale: null,
            content: {}
        };
    },
    created() {
        this.locale = Lang.get();
        this.setLang();
    },
    methods: {
        login() {
          this.loginErr = false;
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    axios.post(
                        'api/login', this.form
                    ).then(res => {
                        Auth.s(res.data.data);
                    }).catch(err => {
                        if (err.response.data.data === 'Unauthorized Access') {
                          this.loginErr = this.content.validation.login;
                        } else if (err.response.data.message === 'Too Many Attempts.'){
                          this.loginErr = this.content.toomany;
                        } else {
                          this.loginErr = this.content.oops;
                        }
                        this.loading = false;
                    });
                }
            },
            setLang() {
                if (this.locale == "en") {
                    this.content = {
                        title: "Sign In",
                        signup: "Sign Up",
                        email: "Email address",
                        password: "Password",
                        signup: "Signup",
                        validation: {
                            email: "Email address is required",
                            password: "Password is required",
                            login: "Email or Password are incorrect"
                        },
                        oops: 'Looks like something went wrong! please try again!',
                        toomany: 'Multiple login attempts made, please wait a minute and try again.',
                    };
                } else if (this.locale == "he") {
                    this.content = {
                        title: "התחבר",
                        signup: "הירשם",
                        email: "כתובת אימייל",
                        password: "סיסמא",
                        signup: "הירשם",
                        validation: {
                            email: "חובה להזין כתובת אימייל",
                            password: "חובה להזין סיסמא",
                            login: "כתובת אימייל ו/או סיסמא אינם נכונים"
                        },
                        oops: 'נראה שמשהו השתבש! אנא נסה שנית!',
                        toomany: 'בוצעו נסיונות התחברות מרובים, אנא המתן דקה ונסה שנית.',
                    };
                }
            }
    }
};

</script>
